module.exports = __webpack_public_path__ + "static/logo-30ce7043799cf001de01bd159eba6914.png";